<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card>
        <v-card-title class="title">
          <v-text-field append-icon="search" label="Quick Search" single-line hide-details v-model="search" clearable style="width: 300px; margin-top: -20px; margin-left: 20px;"></v-text-field>
          <v-spacer></v-spacer>
            <v-btn class="brown lighten-1" fab small dark @click.native="reloadData()">
              <v-icon>refresh</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table class="elevation-1" v-bind:headers="headers" v-bind:items="items" :search="search" v-bind:pagination="pagination" hide-actions style="white-space: nowrap;">
            <template slot="headers" slot-scope="props">
                <tr>
                  <th>ID проверки</th>
                  <th>Сотрудник</th>
                  <th>Размер файла</th>
                  <th>Отправитель</th>
                  <th>Получено от</th>
                  <th>DKIM</th>
                  <th>SPF</th>
                  <th>Время проверки</th>
                  <th>E-mail</th>
                </tr>
          </template>
          <template class="body-2" slot="items" slot-scope="props">
              <td width="150" >{{ props.item.id }} {{ props.item.result === 'pass' ? "✅" : "❌" }} 
              <span style="font-size: 1.5em;"> {{ props.item.mail_check === '0' ? '📧' : ''}} </span></td>

              <td width="150">{{ props.item.nick_name }}</td>
              <td width="150">{{ props.item.file_size }}</td>
              <td>{{ props.item.sender }} </td>
              <td>{{ props.item.received }}</b></td>
              <td>{{ props.item.dkim }}</td>
              <td>{{ props.item.spf }}</td>
              <td>{{ props.item.timestamp }}</td>
              <td><a :href="'https://bankpdf.ru/mail/' + props.item.file + '.eml'" target="_blank">Открыть</a></td>
            <td class="text-xs-right">
            </td>
          </template>
          <template slot="no-data">
           <span >
              <p class="pt-2 blue--text subheading">   <v-icon medium class="blue--text" >info</v-icon>Sorry, nothing to display here :(</p>
            </span>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2" v-if="isNotEmpty">
          <v-pagination v-model="pagination.page" :length="pagination.pages" :total-visible="10" circle></v-pagination>
        </div>
      </v-card>
    </v-flex>
  </v-container>
</template>
<script>
/* global Store */
import { mapState, dispatch } from 'vuex'
import auth from '../utils/auth'
export default {
  data() {
    return {
      search: '',
      query: '',
      headers: [
        { text: '', value: 'result' },
        {
          text: 'ID проверки',
          left: true,
          value: 'id'
        },
        { text: 'Размер файла', value: 'file_size' },
        { text: 'Отправитель', value: 'sender' },
        { text: 'Получено от', value: 'received' },
        { text: 'DKIM', value: 'dkim' },
        { text: 'SPF', value: 'spf' },
        { text: 'Время проверки', value: 'timestamp' },
        { text: 'Чек', value: 'file' },
      ],
      }
    },
    computed: {
      ...mapState("mailchecks", {
        items: "checks",
        worker: "worker",
        pagination: "pagination",
        loading: "loading",
        mode: "mode",
        snackbar: "snackbar",
        notice: "notice"
      }),
      ...mapState(
        "filters", {
          from: "from",
          until: "until",
          fromTime: "fromTime",
          untilTime: "untilTime",
          worker: "worker",
      }),
      isNotEmpty () {
        return this.items && this.items.length > 0;
      }
     },
    methods: {
      closeSnackbar() {
        Store.commit("mailchecks/setSnackbar", { snackbar: false });
        Store.commit("mailchecks/setNotice", { notice: "" });
      },
      reloadData () {
        this.query = "from=" + this.from + "%20" + this.fromTime + "&until=" + this.until + "%20" + this.untilTime + "&worker=" + (this.worker || '');
        this.$Progress.start();
        Store.dispatch('mailchecks/getChecks', this.query)
      },
    },
    watch: {
      from() {
        this.reloadData();
      },
      until() {
        this.reloadData();
      },
      fromTime() {
        this.reloadData();
      },
      untilTime() {
        this.reloadData();
      },
      worker() {
        this.reloadData();
      },
      bank() {
        this.reloadData();
      },
      items() {
        this.$Progress.finish();
      },
    },
    created() {
        this.reloadData();
    },
    mounted() {
        this.$Progress.finish();
    }
  }
</script>



// WEBPACK FOOTER //
// MailList.vue?4dc36c90